import { getCookie } from 'owa-service/lib/universalCookies';
import { getOrigin } from 'owa-url';

export function getDefaultAnchorMailboxCookie() {
    let serverRedirect = getCookie('targetServer');
    let anchorMailboxCookieName =
        'DefaultAnchorMailbox' + (serverRedirect ? '_' + serverRedirect.toLocaleLowerCase() : '');
    let anchorMailboxCookie = getCookie(anchorMailboxCookieName);

    return anchorMailboxCookie;
}

export function getAnchorMailboxHeaderForExplicitLogon() {
    let header = '';

    // see if this is an explicit logon scenario, where the target mailbox is specified in the path
    // e.g., /mail/user@contoso.com/inbox/
    let path = getOrigin();

    let segments = path.split('/').filter(part => part.length);
    if (segments.length >= 2) {
        if (segments[1].match(/.+@.+/)) {
            header = segments[1];
        }
    }

    return header;
}

export function getAnchorMailboxHeader() {
    let header = getAnchorMailboxHeaderForExplicitLogon();

    // if there is no target in the URI, we assume the authenticated user in the default anchor mailbox cookie is the target
    if (!header) {
        header = getDefaultAnchorMailboxCookie();
    }

    return header;
}
